import { useCurrentUser } from "@/hooks/use-current-user";

export const useReferralLink = () => {
  const user = useCurrentUser();

  const getReferralLink = () => {
    if (!user) {
      throw new Error(
        "Could not create a referral link for an unauthorized user",
      );
    }

    return `${window.location.origin}/invite/${user.id}`;
  };

  return {
    getReferralLink,
  };
};
